import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M11 9.5c0 .828-.672 1.5-1.5 1.5S8 10.328 8 9.5 8.672 8 9.5 8s1.5.672 1.5 1.5zM6 9.5c0 .828-.672 1.5-1.5 1.5S3 10.328 3 9.5 3.672 8 4.5 8 6 8.672 6 9.5zM16 9.5c0 .828-.672 1.5-1.5 1.5S13 10.328 13 9.5 13.672 8 14.5 8s1.5.672 1.5 1.5z',
  ],
  height: 20,
  width: 20,
});
